<script>
  import { SPRITESHEET_URL } from '../../utils/constants.ts';
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';
  import BaseLink from '../BaseLink/BaseLink.svelte';
  
  let { icon, headingText, headingLevel = 'h3', description, link, dataTestId = 'topic-tile' } = $props();
</script>

<BaseLink
  className="bg-white border border-gray-light-silver rounded-lg flex items-center p-4 lg:pb-6 hover-hover:hover:bg-blue-very-light active:bg-blue-very-light
  active:shadow-active relative pseudo-shadow-dark-hover lg:flex-col lg:text-center"
  {dataTestId}
  {...link}
>
  <svg class="w-16 h-16 min-w-16 fill-current stroke-current text-blue-cerulean z-10 lg:-mt-8 lg:mb-2">
    <use xlink:href={`${SPRITESHEET_URL}#${icon}`} />
  </svg>
  <div class="ml-6 lg:ml-0">
    <BaseHeading className="sm:text-lg font-bold mb-2" {headingLevel}>{headingText}</BaseHeading>
    <p class="lg:mx-auto lg:px-8">{description}</p>
  </div>
</BaseLink>
